var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 5.917,
  stroke: "#A0A9BE",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#A0A9BE",
  strokeWidth: 1.25,
  d: "M7.333 2s-2 2-2 6 2 6 2 6M8.667 2s2 2 2 6-2 6-2 6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#A0A9BE",
  strokeWidth: 1.25,
  d: "M2 6.333s2-.666 6-.666 6 .666 6 .666M2 9.667s2 .666 6 .666 6-.666 6-.666"
})));
export default SvgArticles;